import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";
import { JWT_STORAGE_KEY } from "../utils/constants";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem(JWT_STORAGE_KEY);
    if (storedToken) {
      setToken(storedToken);
      authService
        .getProfile(storedToken)
        .then((data) => setAdmin(data))
        .catch(() => {
          localStorage.removeItem(JWT_STORAGE_KEY);
          setToken(null);
          setAdmin(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (credentials) => {
    const data = await authService.login(credentials);
    localStorage.setItem(JWT_STORAGE_KEY, data.token);
    setToken(data.token);
    setAdmin(data.admin || null);
    navigate("/analytics");
  };

  const logout = () => {
    localStorage.removeItem(JWT_STORAGE_KEY);
    setToken(null);
    setAdmin(null);
    navigate("/login");
  };

  const isAuthenticated = useMemo(() => {
    return Boolean(token && admin);
  }, [token, admin]);

  return (
    <AuthContext.Provider
      value={{
        token,
        admin,
        isAuthenticated: isAuthenticated,
        loading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
